/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */

import React, { useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
// eslint-disable-next-line import/no-unresolved

import ReplayIcon from '@material-ui/icons/Replay';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import { storeContext } from '../provider/Provider';
import BlueButton from '../../customUI/BlueButton';
import RedButton from '../../customUI/RedButton';

import { leadsActions } from '../../store/leads-reducer';

const MobileLeadsCard = ({ row, pageNumber, rowsPerPage, rowNumber, handleLeadClick, handleLeadRowClick, handleLeadSpamClick, handleDeleteClick }) => {

  const { REACT_APP_HIDE_SPAM } = process.env;

  const { dispatch } = useContext(storeContext);

  const [fullView, setFullview] = useState(false);
  const useStyles = makeStyles(() => ({
    mobileCard: {
      background: 'white',
      borderRadius: '16px',
      padding: 15,
      margin: 10,
      border: '3px white solid',
    },
    flexLine: {
      display: 'flex',
      alignItems: 'center',
      margin: '10px 0',
    },
    flexLineDefault: {
      display: 'flex',
      alignItems: 'center',
    },
  }));

  const handleClick = () => {
    setFullview(!fullView);
  };

  const handleDelete = (event) => {
    event.stopPropagation();
    dispatch({
      type: leadsActions.LEADS_SET_ALL,
      payload: {
        currentLead: row,
      },
    });
    handleLeadRowClick(row.uuid);
    handleDeleteClick();
  };

	const handleAddLead = (event) => {
		event.stopPropagation();
		dispatch({
      type: leadsActions.LEADS_SET_ALL,
      payload: {
        currentLead: row,
      },
    });
    handleLeadRowClick(row.uuid);
    handleLeadClick();
  };

  const handleMarkSpam = (event) => {
    event.stopPropagation();
    dispatch({
      type: leadsActions.LEADS_SET_ALL,
      payload: {
        currentLead: row,
      },
    });
    handleLeadRowClick(row.uuid);
    handleLeadSpamClick();
  };

  
  const classes = useStyles();
  return (
    <>
      <div
        className={classes.mobileCard}
        key={row.leadBody.email}
        onClick={handleClick}
        aria-label="default box"
      >
        {fullView ? (
          <>
            <div className={classes.flexLine}>
            <div style={{ width: '10%', userSelect: 'none' }}>
          {(rowNumber + 1) + (pageNumber * rowsPerPage)}
        </div>
              <div style={{ width: '20%', userSelect: 'none' }}>{`${new Date(
                row.createdAt
              ).toLocaleString('en-US', { month: 'short' })} ${new Date(
                row.createdAt
              ).getFullYear()}`}</div>
              <div style={{ width: '70%', userSelect: 'none' }}>{row.leadBody.fullName}</div>
            </div>
            <div
              style={{ background: '#00B4E0', height: '1px', width: '100%', margin: '10px 0' }}
            />
            {Object.entries(row.leadBody).map(([key, value]) => (
              <React.Fragment key={row.uuid + key }>
                <div className={classes.flexLine}>
                  <div style={{ width: '25%', userSelect: 'none' }}>{key}</div>
                  <div style={{ width: '75%', userSelect: 'none' }}>{value}</div>
                </div>
              </React.Fragment>
            ))}
            <div className={classes.flexLine} style={{ justifyContent: 'center' }}>
              <div style={{ userSelect: 'none' }}>
                {!row.is_spam ? <BlueButton
                  aria-label="convert opportunity to lead"
                  onClick={handleAddLead}
                >
                  Add Lead
                </BlueButton> : <RedButton
                  onClick={handleDelete}
                >
                  <DeleteIcon 
                    style={{ fontSize: 'medium', marginRight: 5 }} 
                  />
                  Delete
                </RedButton>}
              </div>
              {REACT_APP_HIDE_SPAM === "false" && (row.is_spam? (<RedButton
                onClick={handleMarkSpam}
              >
                <ReplayIcon 
                  style={{
                    fontSize: 'medium',
                    marginRight: 5,
                  }}
                />
                Spam
              </RedButton>):
              (<BlueButton
                aria-label="Set spam flag for form"
                onClick={handleMarkSpam}
              >
                Mark Spam
              </BlueButton>))}
            </div>
          </>
        ) : (
          <div className={classes.flexLineDefault}>
            <div style={{ width: '10%', userSelect: 'none' }}>
          {(rowNumber + 1) + (pageNumber * rowsPerPage)}
        </div>
            <div style={{ width: '20%', userSelect: 'none' }}>{`${new Date(
              row.createdAt
            ).toLocaleString('en-US', { month: 'short' })} ${new Date(
              row.createdAt
            ).getFullYear()}`}</div>
            <div style={{ width: '70%', userSelect: 'none' }}>{row.leadBody.fullName}</div>
          </div>
        )}
      </div>  
    </>
  );
};

export default MobileLeadsCard;
